import type { Dispatch } from 'react';
import { TelegramSection } from '../tenant-sections/TelegramSection';
import type { WizardAction, WizardDraft } from './types';

/** Paso 2 del wizard = la sección Telegram montada en modo wizard. */
export function Step2TelegramChannel({
  draft,
  dispatch,
}: {
  draft: WizardDraft;
  dispatch: Dispatch<WizardAction>;
}) {
  return (
    <TelegramSection
      mode="wizard"
      testId="wizard-step-2"
      tenantId={draft?.tenantId ?? ''}
      value={draft?.channels?.telegram ?? {}}
      onSaved={(patch) => {
        const p = patch as { tokenUploaded?: boolean; webhookRegistered?: boolean };
        if (p.tokenUploaded) dispatch({ type: 'mark-telegram-token' });
        if (p.webhookRegistered) dispatch({ type: 'mark-telegram-webhook' });
      }}
      onContinue={() => dispatch({ type: 'goto', step: 3 })}
    />
  );
}
